import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-047d61c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-select" }
const _hoisted_2 = { class: "center" }

import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GameSelect',
  props: {
  value: {
    type: Boolean as PropType<boolean | undefined>,
    default: undefined,
  },
},
  emits: ["select"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'select', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["select", { selected: __props.value === false }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', false)))
    }, [
      _renderSlot(_ctx.$slots, "selectFalse")
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["select", { selected: __props.value === true }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', true)))
    }, [
      _renderSlot(_ctx.$slots, "selectTrue")
    ], 2)
  ]))
}
}

})